import React from 'react'
import { HBox, Wrapper } from 'src/ui/layout'
import { Image } from 'src/ui/atoms'
import { Body, Header } from 'src/ui/typography'

type Props = {
  images: TImages
}
export const Simulator = ({ images }: Props) => {
  return (
    <Wrapper>
      <HBox />

      <Image fluid={images['simulator-mob']} />

      <HBox />

      <Header as="h4" size="h4">
        Симулятор системного анализа
      </Header>

      <HBox height={24} />

      <Body>
        Мы разработали «Симулятор системного анализа», который позволяет
        студентам изучать теорию, выполнять практические задачи на основе
        реальных  кейсов. Мы оцифровали образовательные процессы, ранее
        доступные только на наших оффлайн-стажировках, и предоставили студентам
        практический опыт в IT-сфере без необходимости посещать наш офис.
      </Body>

      <HBox />

      <Body>
        Десятки пользователей смогли пройти обучение и получить практический
        опыт, компетенции и работу в IT-индустрии.
      </Body>

      <HBox />

      <Body weight="medium">
        <a href="https://simulator.kode.ru/" target="_blank">
          Подробнее о программе →
        </a>
      </Body>

      <HBox height={8} />
    </Wrapper>
  )
}
